<section class="desktop-menu" [class.menu-active]="activeFirstMenu">
  <digital-platform-desktop-menu
    [activeMenu]="activeFirstMenu"
  ></digital-platform-desktop-menu>
</section>
<section
  class="mobile-menu"
  [class.mobile-menu_active]="mobileNavOpen"
  data-automation-id="meganav-mobile-active"
>
  <ng-container *ngIf="!activeSecondaryMenu">
    <ul class="list-style-none bottom-border-grey">
      <ng-container *ngFor="let menuKey of menuKeys; let i = index">
        <li
          class="nav-item d-flex align-items-center my-2"
          *ngFor="let item of getMenuItem(menuKey)"
        >
          <a
            [href]="item.main_link_url"
            [routerLink]="item.main_link_url"
            class="p-5 text-decoration-none"
          >
            <digital-platform-rsx-rich-text
              class="text-primary fw-bold"
              [body]="item.main_link_title"
              [attr.data-automation-id]="item.main_link_title"
              >{{ item.main_link_title }}
            </digital-platform-rsx-rich-text>
          </a>
          <span
            class="chevron-right p-5"
            (click)="
              onSetActiveMenu(
                'activeSecondaryMenu',
                item.menu_columns,
                item.main_link_title,
                item.view_all_link
              )
            "
          ></span>
        </li>
      </ng-container>
    </ul>
    <ul class="list-style-none padding-twenty">
      <ng-container *ngFor="let item of config.utility_links; let i = index">
        <li
          class="nav-item d-flex align-items-center"
          style="margin-bottom: 10px"
          *ngIf="item.mobile_title"
        >
          <img
            [src]="'/assets/' + icons[i] + '-red.svg'"
            [alt]="item.link_title + ' Icon'"
            width="20"
            height="20"
            [attr.data-automation-id]="item.mobile_title"
          />
          <digital-platform-rsx-a
            class="rich-text-link"
            klass="text-color-black text-decoration-none ms-5"
            [url]="item.link_url || ''"
            [attr.data-automation-id]="item.mobile_title"
          >
            {{ item.mobile_title }}
          </digital-platform-rsx-a>
        </li>
      </ng-container>
    </ul>
  </ng-container>

  <ul
    *ngIf="activeSecondaryMenu && !activeTertiaryMenu"
    class="list-style-none"
  >
    <ng-container *ngFor="let menu of activeSecondaryMenu.columns">
      <ng-container *ngFor="let column of menu.column; let isFirst = first">
        <li
          class="nav-item d-flex align-items-center my-2"
          *ngIf="isFirst"
          (click)="
            !column.link_url
              ? onSetActiveMenu(
                  'activeTertiaryMenu',
                  menu.column,
                  column.link_title,
                  menu.view_all_link
                )
              : null
          "
        >
          <digital-platform-rsx-a
            *ngIf="column.link_url"
            klass="text-color-black text-decoration-none"
            class="p-5"
            [url]="column.link_url"
            [attr.data-automation-id]="column.link_title"
          >
            {{ column.link_title }}
          </digital-platform-rsx-a>

          <ng-container *ngIf="!column.link_url">
            <digital-platform-rsx-rich-text
              class="text-color-black p-5"
              [body]="column.link_title"
              [attr.data-automation-id]="column.link_title"
              >{{ column.link_title }}
            </digital-platform-rsx-rich-text>
          </ng-container>

          <span
            class="chevron-right p-5"
            *ngIf="menu.column.length > 1"
            (click)="
              onSetActiveMenu(
                'activeTertiaryMenu',
                menu.column,
                column.link_title,
                menu.view_all_link
              )
            "
          ></span>
        </li>
      </ng-container>
    </ng-container>
  </ul>

  <ul
    *ngIf="activeTertiaryMenu"
    class="list-style-none"
    data-automation-id="meganav-mobile-tertiary-menu"
  >
    <ng-container *ngFor="let column of activeTertiaryMenu.columns">
      <li
        class="nav-item d-flex align-items-center mt-7 mb-7"
        *ngIf="column.link_url"
      >
        <digital-platform-rsx-a
          klass="text-color-black text-decoration-none"
          [url]="column.link_url"
          [attr.data-automation-id]="column.link_title"
        >
          {{ column.link_title }}
        </digital-platform-rsx-a>
      </li>
    </ng-container>
    <digital-platform-cta-button
      *ngIf="viewAllLink"
      linkClass="mt-11"
      (click)="closeMenuIfNeeded()"
      [ctaStyle]="{ ctaStyle: 'button__link_primary' }"
      [url]="viewAllLink"
    >
      View All
    </digital-platform-cta-button>
  </ul>
</section>
